import { useMemo } from "react";

import {
  Avatar,
  AvatarProps,
  Typography,
  TypographyProps,
} from "@mui/material";

import { UserOutlinedIcon } from "@robin/common";

import { Patient } from "../models/patient";
import { functionalColors } from "../utils/colorUtils";
import { tableHash } from "../utils/hashUtils";

export const PatientAvatar: React.FC<
  AvatarProps & { typographyProps?: TypographyProps; patient?: Patient }
> = ({ patient, typographyProps, ...avatarProps }) => {
  const bgcolor = useMemo(() => {
    if (!patient) return;
    return functionalColors[tableHash(patient.id, functionalColors.length)];
  }, [patient]);

  const initials = useMemo(() => {
    if (!patient) return;
    return patient?.name
      .split(" ")
      .map((n) => n[0])
      .join("")
      .substring(0, 2)
      .toUpperCase();
  }, [patient]);

  return (
    <Avatar {...avatarProps} sx={{ bgcolor, ...avatarProps.sx }}>
      {patient ? (
        <Typography variant="subtitle1" {...typographyProps}>
          {initials}
        </Typography>
      ) : (
        <UserOutlinedIcon fontSize="small" />
      )}
    </Avatar>
  );
};
